import React, { useEffect } from 'react';
import { FormControl, FormControlLabel, FormGroup, Checkbox as MuiCheckbox } from '@mui/material';

const CheckBox = ({ item, onChange }) => {
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option) ? prev.filter((o) => o !== option) : [...prev, option]
    );
  };

  useEffect(() => {
    if (item?.answer && item.answer.length) {
      setSelectedOptions([...item.answer]);
    }
  }, []);

  useEffect(() => {
    if (item) item.answer = selectedOptions;
    if (onChange) onChange(selectedOptions);
  }, [selectedOptions, item, onChange]);

  return (
    <div>
      <FormControl fullWidth component="fieldset" sx={{ marginLeft: '7px' }}>
        <FormGroup>
          {item?.options?.map((option, optionIndex) => (
            <FormControlLabel
              key={optionIndex}
              control={
                <MuiCheckbox
                  checked={selectedOptions.includes(option.text)}
                  onChange={() => handleCheckboxChange(option.text)}
                />
              }
              label={option.text}
              sx={{
                margin: '0px'
              }}
            />
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default CheckBox;
